var _circle, _g, _g2, _circle2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDataFlow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 800,
    height: 600,
    viewBox: "0 0 800 600",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 400,
    cy: 300,
    r: 40,
    fill: "#134e4a",
    stroke: "#115e59",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "r",
    values: "40;45;40",
    dur: "2s",
    repeatCount: "indefinite"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "nodes"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 150,
    cy: 180,
    r: 20,
    fill: "#134e4a",
    stroke: "#115e59",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 150,
    cy: 260,
    r: 20,
    fill: "#134e4a",
    stroke: "#115e59",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 150,
    cy: 340,
    r: 20,
    fill: "#134e4a",
    stroke: "#115e59",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 150,
    cy: 420,
    r: 20,
    fill: "#134e4a",
    stroke: "#115e59",
    strokeWidth: 2
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "connections"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M170 180l230 120",
    stroke: "#115e59",
    strokeWidth: 2,
    strokeDasharray: "5 3"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke-dashoffset",
    values: "0;-16",
    dur: "1s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M170 260l230 40",
    stroke: "#115e59",
    strokeWidth: 2,
    strokeDasharray: "5 3"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke-dashoffset",
    values: "0;-16",
    dur: "1s",
    begin: "0.25s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M170 340l230-40",
    stroke: "#115e59",
    strokeWidth: 2,
    strokeDasharray: "5 3"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke-dashoffset",
    values: "0;-16",
    dur: "1s",
    begin: "0.5s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M170 420l230-120",
    stroke: "#115e59",
    strokeWidth: 2,
    strokeDasharray: "5 3"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke-dashoffset",
    values: "0;-16",
    dur: "1s",
    begin: "0.75s",
    repeatCount: "indefinite"
  })))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 400,
    cy: 300,
    r: 60,
    fill: "rgba(19, 78, 74, 0.2)",
    filter: "blur(10px)"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "r",
    values: "60;70;60",
    dur: "2s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    values: "0.1;0.2;0.1",
    dur: "2s",
    repeatCount: "indefinite"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDataFlow);
export default __webpack_public_path__ + "static/media/data-flow.a8de02a2068cf83b2ddad758de157afb.svg";
export { ForwardRef as ReactComponent };